// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1924":"a24590d2","5392":"e5f62a5f"}[chunkId] + ".chunk.css";
};